export function init(Survey: any) {
  var widget = {
    //the widget name. It should be unique and written in lowcase.
    name: "foto",
    //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
    title: "Text with button",
    //the name of the icon on the toolbox. We will leave it empty to use the standard one
    iconName: "",
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function () {
      //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page
      return true; //we do not require anything so we just return true.
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function (question) {
      //we return true if the type of question is textwithbutton
      return question.getType() === "foto";
      //the following code will activate the widget for a text question with inputType equals to date
      //return question.getType() === 'text' && question.inputType === "date";
    },
    //Use this function to create a new class or add new properties or remove unneeded properties from your widget
    //activatedBy tells how your widget has been activated by: property, type or customType
    //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
    //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
    //customType - you are creating a new type, like in our example "foto"
    activatedByChanged: function (activatedBy) {
      //we do not need to check acticatedBy parameter, since we will use our widget for customType only
      //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
      Survey.JsonObject.metaData.addClass("foto", [], null, "text");
      //signaturepad is derived from "empty" class - basic question class
      //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

      //Add new property(s)
      //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
      Survey.JsonObject.metaData.addProperties("foto", [
        { name: "buttonText", default: "Click Me" },
      ]);
    },
    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    isDefaultRender: false,
    //You should use it if your set the isDefaultRender to false
    htmlTemplate: "<div><span><img src=\"\"><input type='hidden'><button (click)=\"tomarfoto()\" ></button><span></span><span></div>",
    //The main function, rendering and two-way binding
    afterRender: function (question, el) {
      //el is our root element in htmlTemplate, is "div" in our case
      //get the text element
      var text = el.getElementsByTagName("input")[0];
      var span=el.getElementsByTagName("span")[0];
      var imagen=el.getElementsByTagName("img")[0];
      //set some properties
      text.inputType = question.inputType;
      text.placeholder = question.placeHolder;
      imagen.src=question.value;
      let r = Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7);
      //text.id=r;
      span.id=r;

      //get button and set some rpoeprties
      var button = el.getElementsByTagName("button")[0];
      //button.innerText = question.buttonText;
      button.innerText = "Tomar foto";

      button.onclick = function () {
        var puente = document.getElementById("inputp");
        puente["value"]=r;

        
        puente.click();
        console.log(question);

        //alert("hola");
      };
      var button2= el.getElementsByTagName("span")[1];

      button2.onclick = function () {

        question.value = text.value;

      };

      //set the changed value into question value
      text.onchange = function () {
        question.value = text.value;
      };
      var onValueChangedCallback = function () {
        text.value = question.value ? question.value : "";
      };
      var onReadOnlyChangedCallback = function () {
        if (question.isReadOnly) {
          text.setAttribute("disabled", "disabled");
          button.setAttribute("disabled", "disabled");
        } else {
          text.removeAttribute("disabled");
          button.removeAttribute("disabled");
        }
      };
      //if question becomes readonly/enabled add/remove disabled attribute
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      //if the question value changed in the code, for example you have changed it in JavaScript
      question.valueChangedCallback = onValueChangedCallback;
      //set initial value
      onValueChangedCallback();
      //make elements disabled if needed
      onReadOnlyChangedCallback();
    },
    //Use it to destroy the widget. It is typically needed by jQuery widgets
    willUnmount: function (question, el) {
      //We do not need to clear anything in our simple example
      //Here is the example to destroy the image picker
      //var $el = $(el).find("select");
      //$el.data('picker').destroy();
    },
  };

  //Register our widget in singleton custom widget collection
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, "customtype");

  var widgetfotobaja = {
    //the widget name. It should be unique and written in lowcase.
    name: "fotobaja",
    //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
    title: "Foto Baja",
    //the name of the icon on the toolbox. We will leave it empty to use the standard one
    iconName: "",
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function () {
      //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page
      return true; //we do not require anything so we just return true.
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function (question) {
      //we return true if the type of question is textwithbutton
      return question.getType() === "fotobaja";
      //the following code will activate the widget for a text question with inputType equals to date
      //return question.getType() === 'text' && question.inputType === "date";
    },
    //Use this function to create a new class or add new properties or remove unneeded properties from your widget
    //activatedBy tells how your widget has been activated by: property, type or customType
    //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
    //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
    //customType - you are creating a new type, like in our example "foto"
    activatedByChanged: function (activatedBy) {
      //we do not need to check acticatedBy parameter, since we will use our widget for customType only
      //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
      Survey.JsonObject.metaData.addClass("fotobaja", [], null, "text");
      //signaturepad is derived from "empty" class - basic question class
      //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

      //Add new property(s)
      //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
      Survey.JsonObject.metaData.addProperties("foto", [
        { name: "buttonText", default: "Click Me" },
      ]);
    },
    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    isDefaultRender: false,
    //You should use it if your set the isDefaultRender to false
    htmlTemplate: "<div><span><img src=\"\"><input type='hidden'><button (click)=\"tomarfoto()\" ></button><span></span><span></div>",
    //The main function, rendering and two-way binding
    afterRender: function (question, el) {
      //el is our root element in htmlTemplate, is "div" in our case
      //get the text element
      var text = el.getElementsByTagName("input")[0];
      var span=el.getElementsByTagName("span")[0];
      var imagen=el.getElementsByTagName("img")[0];
      //set some properties
      text.inputType = question.inputType;
      text.placeholder = question.placeHolder;
      imagen.src=question.value;
      let r = Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7);
      //text.id=r;
      span.id=r;

      //get button and set some rpoeprties
      var button = el.getElementsByTagName("button")[0];
      //button.innerText = question.buttonText;
      button.innerText = "Tomar foto";

      button.onclick = function () {
        var puente = document.getElementById("inputfotobaja");
        puente["value"]=r;

        
        puente.click();
        console.log(question);

        //alert("hola");
      };
      var button2= el.getElementsByTagName("span")[1];

      button2.onclick = function () {

        question.value = text.value;

      };

      //set the changed value into question value
      text.onchange = function () {
        question.value = text.value;
      };
      var onValueChangedCallback = function () {
        text.value = question.value ? question.value : "";
      };
      var onReadOnlyChangedCallback = function () {
        if (question.isReadOnly) {
          text.setAttribute("disabled", "disabled");
          button.setAttribute("disabled", "disabled");
        } else {
          text.removeAttribute("disabled");
          button.removeAttribute("disabled");
        }
      };
      //if question becomes readonly/enabled add/remove disabled attribute
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      //if the question value changed in the code, for example you have changed it in JavaScript
      question.valueChangedCallback = onValueChangedCallback;
      //set initial value
      onValueChangedCallback();
      //make elements disabled if needed
      onReadOnlyChangedCallback();
    },
    //Use it to destroy the widget. It is typically needed by jQuery widgets
    willUnmount: function (question, el) {
      //We do not need to clear anything in our simple example
      //Here is the example to destroy the image picker
      //var $el = $(el).find("select");
      //$el.data('picker').destroy();
    },
  };

  //Register our widget in singleton custom widget collection
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widgetfotobaja, "customtype");

  var escanearwidget = {
    //the widget name. It should be unique and written in lowcase.
    name: "escanear",
    //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
    title: "Escanear Documento",
    //the name of the icon on the toolbox. We will leave it empty to use the standard one
    iconName: "",
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function () {
        //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page
        return true; //we do not require anything so we just return true.
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function (question) {
        //we return true if the type of question is textwithbutton
        return question.getType() === "escanear";
        //the following code will activate the widget for a text question with inputType equals to date
        //return question.getType() === 'text' && question.inputType === "date";
    },
    //Use this function to create a new class or add new properties or remove unneeded properties from your widget
    //activatedBy tells how your widget has been activated by: property, type or customType
    //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
    //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
    //customType - you are creating a new type, like in our example "foto"
    activatedByChanged: function (activatedBy) {
        //we do not need to check acticatedBy parameter, since we will use our widget for customType only
        //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
        Survey.JsonObject.metaData.addClass("escanear", [], null, "text");
        //signaturepad is derived from "empty" class - basic question class
        //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

        //Add new property(s)
        //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
        Survey.JsonObject.metaData.addProperties("escanear", [
          { name: "CampoTipoDocumento", default: "" },
          { name: "CampoDocumento", default: "" },
            { name: "CampoPrimerNombre", default: "" },
            { name: "CampoSegundoNombre", default: "" },
            { name: "CampoPrimerApellido", default: "" },
            { name: "CampoSegundoApellido", default: "" },
            { name: "CampoFechaNacimiento", default: "" },
            { name: "CampoNombreCompleto", default: "" },
            { name: "CampoTipoDeSangre", default: "" },
            { name: "CampoSexo", default: "" },
        ]);
    },
    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    isDefaultRender: false,
    //You should use it if your set the isDefaultRender to false
    htmlTemplate: "<div><span><input type='hidden'><button></button> <button (click)=\"pasardatos('escanear')\" ></button><span></span><span></div>",
    //The main function, rendering and two-way binding
    afterRender: function (question, el) {
        //el is our root element in htmlTemplate, is "div" in our case
        //get the text element
        var text = el.getElementsByTagName("input")[0];
        var span = el.getElementsByTagName("span")[0];
        var BotonPasarDatos =el.getElementsByTagName("button")[1];

        
        //set some properties
        text.inputType = question.inputType;
        text.placeholder = question.placeHolder;
        //imagen.src = question.value;
        let r = Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7);
        //text.id=r;
        span.id = r;
        //p.innerHTML = question.CampoPrimerNombre;

        //get button and set some rpoeprties
        var button = el.getElementsByTagName("button")[0];
        //button.innerText = question.buttonText;
        button.innerText = "Escanear documento";

        button.onclick = function () {
            var puente = document.getElementById("inputpescanear");
            puente["value"] = r;
            puente.click();
            console.log(question);
            //alert("hola");
        };

        BotonPasarDatos.onclick = function () {
          var puente = document.getElementById("inputpescanear");
          puente["value"] = r;
          puente.click();
          console.log(question);
          //alert("hola");
      };

        var button2 = el.getElementsByTagName("span")[1];

        button2.onclick = function () {

            question.value = text.value;

        };

        //set the changed value into question value
        text.onchange = function () {
          console.log("SE ESTA EJECUTANDO ONCHANGE");
          console.log(Survey);

          

          
          //Survey.surveyModel.setValue(CampoPrimerNombre,integrante.PrimerNombre);




          question.value = text.value;
        };
        var onValueChangedCallback = function () {
            text.value = question.value ? question.value : "";
        };
        var onReadOnlyChangedCallback = function () {
            if (question.isReadOnly) {
                text.setAttribute("disabled", "disabled");
                button.setAttribute("disabled", "disabled");
            } else {
                text.removeAttribute("disabled");
                button.removeAttribute("disabled");
            }
        };
        //if question becomes readonly/enabled add/remove disabled attribute
        question.readOnlyChangedCallback = onReadOnlyChangedCallback;
        //if the question value changed in the code, for example you have changed it in JavaScript
        question.valueChangedCallback = onValueChangedCallback;
        //set initial value
        onValueChangedCallback();
        //make elements disabled if needed
        onReadOnlyChangedCallback();
    },
    //Use it to destroy the widget. It is typically needed by jQuery widgets
    willUnmount: function (question, el) {
        //We do not need to clear anything in our simple example
        //Here is the example to destroy the image picker
        //var $el = $(el).find("select");
        //$el.data('picker').destroy();
    },
};

//Register our widget in singleton custom widget collection


Survey.CustomWidgetCollection.Instance.add(escanearwidget, "customtype");

var widgetubicacion = {
  //the widget name. It should be unique and written in lowcase.
  name: "ubicacion",
  //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
  title: "Ubicacion",
  //the name of the icon on the toolbox. We will leave it empty to use the standard one
  iconName: "",
  //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
  widgetIsLoaded: function () {
    //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page
    return true; //we do not require anything so we just return true.
  },
  //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
  isFit: function (question) {
    //we return true if the type of question is textwithbutton
    return question.getType() === "ubicacion";
    //the following code will activate the widget for a text question with inputType equals to date
    //return question.getType() === 'text' && question.inputType === "date";
  },
  //Use this function to create a new class or add new properties or remove unneeded properties from your widget
  //activatedBy tells how your widget has been activated by: property, type or customType
  //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
  //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
  //customType - you are creating a new type, like in our example "foto"
  activatedByChanged: function (activatedBy) {
    //we do not need to check acticatedBy parameter, since we will use our widget for customType only
    //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
    Survey.JsonObject.metaData.addClass("ubicacion", [], null, "text");
    //signaturepad is derived from "empty" class - basic question class
    //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

    //Add new property(s)
    //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
    Survey.JsonObject.metaData.addProperties("texto_boton", [
      { name: "buttonText", default: "Obtener ubicación" },
    ]);
  },
  //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
  isDefaultRender: false,
  //You should use it if your set the isDefaultRender to false
  htmlTemplate: "<div><span><input disabled ><button (click)=\"tomarfoto()\" ></button><span></span><span></div>",
  //The main function, rendering and two-way binding
  afterRender: function (question, el) {
    //el is our root element in htmlTemplate, is "div" in our case
    //get the text element
    var text = el.getElementsByTagName("input")[0];
    var span=el.getElementsByTagName("span")[0];
    //set some properties
    text.inputType = question.inputType;
    text.placeholder = question.placeHolder;
    let r = Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7)+Math.random().toString(36).substring(7);
    //text.id=r;
    span.id=r;

    //get button and set some rpoeprties
    var button = el.getElementsByTagName("button")[0];
    //button.innerText = question.buttonText;
    button.innerText = "Obtener ubicación";

    button.onclick = function () {
      var puente = document.getElementById("inputubicacion");
      puente["value"]=r;

      
      puente.click();
      console.log(question);

      //alert("hola");
    };
    var input= el.getElementsByTagName("span")[0];

    input.onclick = function () {

      question.value = text.value;

    };

    //set the changed value into question value
    text.onchange = function () {
      question.value = text.value;
    };
    var onValueChangedCallback = function () {
      text.value = question.value ? question.value : "";
    };
    var onReadOnlyChangedCallback = function () {
      if (question.isReadOnly) {
        text.setAttribute("disabled", "disabled");
        button.setAttribute("disabled", "disabled");
      } else {
        //text.removeAttribute("disabled");
        //button.removeAttribute("disabled");
      }
    };
    //if question becomes readonly/enabled add/remove disabled attribute
    question.readOnlyChangedCallback = onReadOnlyChangedCallback;
    //if the question value changed in the code, for example you have changed it in JavaScript
    question.valueChangedCallback = onValueChangedCallback;
    //set initial value
    onValueChangedCallback();
    //make elements disabled if needed
    onReadOnlyChangedCallback();
  },
  //Use it to destroy the widget. It is typically needed by jQuery widgets
  willUnmount: function (question, el) {
    //We do not need to clear anything in our simple example
    //Here is the example to destroy the image picker
    //var $el = $(el).find("select");
    //$el.data('picker').destroy();
  },
};

//Register our widget in singleton custom widget collection
Survey.CustomWidgetCollection.Instance.addCustomWidget(widgetubicacion, "customtype");

}
